import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clapperboard, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function CommunityGoal() {
  const [data, setData] = useState(null);
  const [shown, setShown] = useState(0);

  useEffect(() => {
    api.get("/stats/community").then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!data) return;
    const target = data.videos;
    const start = performance.now();
    const dur = 1400;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setShown(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [data]);

  if (!data) return null;
  const pct = Math.min(100, Math.round((data.videos / data.goal) * 100));

  return (
    <section className="py-16 px-5 border-t border-white/10" data-testid="community-goal">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-xs text-zinc-300 mb-5">
          <Clapperboard className="h-3.5 w-3.5 text-blue-400" /> Community goal
        </div>
        <h2 className="font-head text-lg md:text-3xl font-bold tracking-tight">
          Help the community reach a goal of <span className="text-blue-500">{data.goal.toLocaleString()}</span> created videos
        </h2>
        <p className="mt-6 font-head text-5xl md:text-6xl font-black tracking-tight" data-testid="community-count">
          {shown.toLocaleString()}
        </p>
        <p className="mt-1 text-sm text-zinc-500">videos created by creators like you — and counting</p>
        <div className="mt-6 max-w-xl mx-auto">
          <div className="h-3 rounded-full bg-white/5 border border-white/10 overflow-hidden" data-testid="community-progress">
            <div
              className="h-full bg-gradient-to-r from-blue-600 to-blue-400 rounded-full transition-all duration-1000"
              style={{ width: `${Math.max(pct, 2)}%` }}
            />
          </div>
          <div className="mt-2 flex justify-between text-xs text-zinc-500">
            <span>{pct}% there</span>
            <span>{data.goal.toLocaleString()}</span>
          </div>
        </div>
        <p className="mt-5 text-sm text-zinc-300" data-testid="community-bonus-note">
          🎁 When we hit {data.goal.toLocaleString()}, <span className="text-blue-400 font-semibold">every member gets +{data.bonus} bonus credits</span>.
        </p>
        {data.last_goal_reached && (
          <p className="mt-2 text-xs text-emerald-400" data-testid="community-last-goal">
            🎉 Last goal of {data.last_goal_reached.toLocaleString()} smashed — everyone earned +{data.bonus} credits!
          </p>
        )}
        <Link
          to="/register"
          data-testid="community-goal-cta"
          className="mt-7 inline-flex items-center gap-2 bg-white/5 border border-white/10 hover:bg-white/10 px-5 py-2.5 rounded-md text-sm font-semibold transition-colors"
        >
          Add your video to the count <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
